import { render, staticRenderFns } from "./allTable.vue?vue&type=template&id=0d2ded18&scoped=true&"
import script from "./allTable.vue?vue&type=script&lang=js&"
export * from "./allTable.vue?vue&type=script&lang=js&"
import style0 from "./allTable.vue?vue&type=style&index=0&id=0d2ded18&lang=scss&scoped=true&"
import style1 from "./allTable.vue?vue&type=style&index=1&id=0d2ded18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2ded18",
  null
  
)

export default component.exports